import SecondaryButton from "./common/secondary-btn"

export default function Service({toggleModal, id}){
    const title ="Our Services"

    const servicelist =[
{
    title:'End-to-End Stripe Integration ',
    icon:'https://glocify.com/images/ser1.svg',
    desc:'We can handle the complete integration of the Stripe Payment Gateway in your application. Our expertise includes integrating Stripe in mobile apps, custom web applications, eCommerce platforms, and any other area where you require Stripe integration.'
},{
    title:'Marketplace Integration ',
    icon:'https://glocify.com/images/ser2.svg',
    desc:'We can integrate Stripe Connect to enable seamless marketplace integration. This will give you complete control over the commissions you receive, with payments being directly processed to the merchant accounts.'
}
,{
    title:'CMS Integration ',
    icon:'https://glocify.com/images/ser3.svg',
    desc:'We integrate Stripe with WordPress, Shopify, Magento, and any other custom CMS of your choice. If you have any unique requirements, we can handle those as well. '
}
,{
    title:'In-Person Payments ',
    icon:'https://glocify.com/images/ser4.svg',
    desc:"We specialize in integrating Stripe for in-person payments. Whether your POS system is built on Android, iOS, or Web, we can seamlessly integrate Stripe. We support integration with all Stripe hardware, including M2, S700, and BBPOS. We've got you covered."
}
    ]
return (

    <section className="section-1 pb-[40px] lg:pt-[50px] pt-[30px] md:pt-[50px] " id={id}>
        <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
            <div className="text-center">
                <h1 className='lg:text-[55px] text-[35px] mb-4 font-bold text-[#262626] relative inline-block'>{title} <span className=" rounded-[20px] w-[80px] m-auto h-[5px] bg-[#FB802C] block"></span></h1>
            <ul className="p-0 m-0 flex flex-wrap justify-between">
                {servicelist.map((item, index) => (

                <li key={index} className="lg:w-[45%] md:w-[48%] w-[100%] mt-[50px]" data-aos="fade-down"    data-aos-offset='150'  data-aos-duration={(index + 1) * 350}>
                    <div className="flex space-x-[20px] items-center"><img src={item.icon} alt="services" /> <h1 className="tracking-tight lg:text-[32px] text-[24px] font-bold text-[#262626] text-left ">{item.title}</h1></div>
                    <p className="text-left text-[#262626] text-[16px] font-regular pt-[20px]">{item.desc}</p>               
                    </li>
                ))}
            </ul>
            <div  className="mt-[50px]">  <SecondaryButton  title="Talk to an Expert"  toggleModal={toggleModal}/>  </div>            
            </div>
    </div>
    </section>

)

}